import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { AnthropicAuthInfo } from "@/types";

// #227: Anthropic-Auth-Status. Ohne agentId → Plattform-Default (GET /anthropic-auth);
// mit agentId → per-Agent-Override (GET /agents/:id/anthropic-auth). Admin-only (RBAC
// am Master). Das Secret ist write-only → die Response trägt nur isSet/method/updatedAt.
export function useAnthropicAuth(agentId?: string): UseQueryResult<AnthropicAuthInfo> {
  const { session, logout } = useAuth();
  const path = agentId ? `/agents/${agentId}/anthropic-auth` : "/anthropic-auth";
  const key = agentId
    ? queryKeys.subResource("agents", agentId, "anthropic-auth")
    : queryKeys.list("anthropic-auth");
  return useQuery({
    queryKey: key,
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<AnthropicAuthInfo>(path);
    },
    enabled: !!session,
  });
}
